import { isEmpty, map } from 'lodash'

import ClickableIcon from '@/components/ClickableIcon'
import { Delete, Edit2 } from '@/components/Icons'
import { Role } from '@/components/RolesContainer'
import filterSpaceRoles from '@/components/RolesContainer/filterSpaceRoles'
import useFeatures from '@/components/useFeatures'

import messages from './messages'

export default ({ intl, onDelete, onEdit }: any) => [
  {
    property: 'displayName',
    header: { label: intl.formatMessage(messages.name), sortable: true },
    cell: {
      formatters: [
        (displayName: any, { rowData }: any) => (
          <>
            <p className="user-display__name">
              <span className="user-display__name--emphasize">{displayName}</span>
              <span className="user-display__name--subtle">{rowData.email}</span>
            </p>

            <SpaceRolesList spaceRoles={rowData.rolesInSpace} />
          </>
        )
      ]
    }
  },
  {
    property: 'id',
    cell: {
      // TODO Make this a button
      formatters: [(id: any) => <ClickableIcon callback={onEdit} parameter={id} render={Edit2} />]
    }
  },
  {
    property: 'id',
    cell: {
      // TODO Make this a button
      formatters: [(id: any) => <ClickableIcon callback={onDelete} parameter={id} render={Delete} />]
    }
  }
]

interface RolesListProps {
  spaceRoles?: { name: Role; displayName: string }[]
}

function SpaceRolesList(props: RolesListProps) {
  const features = useFeatures()

  let spaceRoles = props.spaceRoles

  spaceRoles = filterSpaceRoles(spaceRoles, features)

  if (isEmpty(spaceRoles)) return null
  return <p>{map(spaceRoles, 'displayName').join(', ')}</p>
}
